import React from 'react';
import { motion } from 'framer-motion';
import {
  FaPython, FaDocker, FaAws, FaGitAlt, FaDatabase, FaChartBar
} from 'react-icons/fa';
import {
  SiTensorflow, SiPytorch, SiPandas, SiNumpy, SiMongodb,
  SiRedis, SiPostgresql, SiFastapi, SiFlask, SiApachespark,
  SiMlflow
} from 'react-icons/si';
import './Skills.css';

const skillCategories = [
  {
    title: 'Programming',
    skills: [
      { name: 'Python', icon: <FaPython /> },
    ],
  },
  {
    title: 'Machine Learning & AI',
    skills: [
      { name: 'LangChain', icon: null },
      { name: 'LangGraph', icon: null },
      { name: 'TensorFlow', icon: <SiTensorflow /> },
      { name: 'PyTorch', icon: <SiPytorch /> },
      { name: 'scikit-learn', icon: null },
      { name: 'Deep Learning', icon: null },
      { name: 'NLP', icon: null },
      { name: 'LLM Fine-tuning', icon: null },
    ],
  },
  {
    title: 'Databases',
    skills: [
      { name: 'PostgreSQL', icon: <SiPostgresql /> },
      { name: 'MongoDB', icon: <SiMongodb /> },
      { name: 'Redis', icon: <SiRedis /> },
      { name: 'Pinecone', icon: null },
      { name: 'Chroma', icon: null },
    ],
  },
  {
    title: 'Data & Analytics',
    skills: [
      { name: 'Pandas', icon: <SiPandas /> },
      { name: 'NumPy', icon: <SiNumpy /> },
      { name: 'PySpark', icon: <SiApachespark /> },
      { name: 'Power BI', icon: <FaChartBar /> },
      { name: 'Seaborn', icon: null },
      { name: 'Matplotlib', icon: null },
    ],
  },
  {
    title: 'API & Frameworks',
    skills: [
      { name: 'FastAPI', icon: <SiFastapi /> },
      { name: 'Flask', icon: <SiFlask /> },
    ],
  },
  {
    title: 'DevOps & Cloud',
    skills: [
      { name: 'Docker', icon: <FaDocker /> },
      { name: 'MLflow', icon: <SiMlflow /> },
      { name: 'Git', icon: <FaGitAlt /> },
      { name: 'AWS EC2', icon: <FaAws /> },
      { name: 'AWS S3', icon: <FaAws /> },
      { name: 'AWS Redshift', icon: <FaDatabase /> },
      { name: 'AWS CloudWatch', icon: <FaAws /> },
    ],
  },
];

const Skills = () => {
  return (
    <section id="skills" className="skills">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{'// Tech Stack'}</span>
          <h2 className="section-title">Skills & Technologies</h2>
          <p className="section-subtitle">
            Tools and technologies I use to build intelligent AI systems
          </p>
        </div>

        <div className="skills__grid">
          {skillCategories.map((cat, catIdx) => (
            <motion.div
              className="skills__category"
              key={cat.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: catIdx * 0.1, duration: 0.5 }}
            >
              <h3 className="skills__category-title">{cat.title}</h3>
              <div className="skills__items">
                {cat.skills.map((skill) => (
                  <div className="skills__item" key={skill.name}>
                    {skill.icon && <span className="skills__icon">{skill.icon}</span>}
                    <span className="skills__name">{skill.name}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
